module.exports = __webpack_public_path__ + "static/media/logo-text.fe7bd8ce.svg";